const notes = {
  notes: `Notas`,
  note: `Nota`,
  no_notes_found: `No se encontraron notas`,
  add_a_note: `Añadir una nota`,
  note_is_required: `La nota es obligatoria`,
  note_validation_max_length: `La nota no puede tener más de 1000 characteres`,
  notes_length_exceed: `Se excedió la longitud de las notas`,
  delete_note_title: `Eliminar nota`,
  delete_note_confirmation: `¿Estás seguro de que quieres eliminar esta nota? Esta acción no se puede deshacer.`,
  note_deletedBy_deletedOn: `Eliminado por {{deletedBy}} el {{deletedOn}}`,
  document_note_not_owner: `No eres el propietario de esta nota y no puedes realizar esta acción.`,
};
export default notes;
